import * as React from "react";
const SvgArrowDown = props => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 12 6" {...props}><path fill="#1B1D1F" fillRule="evenodd" d="M10 0h2L6 6 0 0h2l4 4z" /></svg>;
export default SvgArrowDown;